import type { ReactNode } from 'react';
import type { Role } from '@features/user-access/types';

import { useUser } from '@features/user-access/providers/user-provider';

type Props = {
  role: Role;
  children: ReactNode;
};

/**
 * Restricts a route to users holding the given warehouse role.
 * Same rule as the dashboard menu: roles are resolved by the backend (role hierarchy included).
 */
export const RoleGuard = ({ role, children }: Props) => {
  const {
    userAccess: { warehouse },
  } = useUser();

  if (!warehouse?.roles.includes(role)) {
    return <div>Accès refusé. Vous n&apos;avez pas les droits nécessaires pour accéder à cette page.</div>;
  }

  return <>{children}</>;
};
